/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import { TextDiv } from './WrapperDiv';

export const IntroVisitDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  align-items: flex-end;
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: stretch;
    gap: 0;
    max-width: 100%;
    box-sizing: border-box;
    & ${TextDiv} {
      justify-content: flex-start;
      text-align: left;
      width: 100%;
    }
    &:first-of-type {
      margin-bottom: 6px;
    }
  }
`;

/** Stacked field groups for VisitIntro on narrow viewports */
export const VisitIntroStack = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  gap: 10px;
  @media (max-width: 600px) {
    gap: 6px;
  }
`;

export const VisitIntroLabeledRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  gap: 10px;
  @media (max-width: 600px) {
    gap: 6px;
    min-width: 0;
  }
  & ${TextDiv} {
    padding-left: 4px;
    padding-right: 4px;
  }
  & .react-datepicker__input-container input {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 1.5;
  }
`;

export const VisitInterfaceDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  margin-bottom: 5px;
  & .react-datepicker__input-container input {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 1.5;
  }
  @media (max-width: 600px) {
    flex-wrap: wrap;
    row-gap: 8px;
    align-items: flex-start;
  }
`;

export const MinVisitTitle = styled.div`
  width: max-content;
  margin-right: 5px;
`;

export const VisitSubmitDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
  margin-top: 5%;
  & button {
    margin-left: 6px;
  }
  margin: 10px;
  position: absolute;
  bottom: 0;
  right: 0;
  @media (max-width: 600px) {
    position: static;
    margin: 16px 4px 4px;
    flex-shrink: 0;
  }
`;

export const VisitButtonDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: right;
  width: 100%;
  @media (max-width: 600px) {
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-end;
    align-items: stretch;
    & button {
      margin-left: 0;
      flex: 1 1 auto;
      min-width: calc(33% - 8px);
    }
  }
  @media (max-width: 380px) {
    flex-direction: column;
    & button {
      width: 100%;
      min-width: unset;
    }
  }
`;

export const VisitButtonDivCenter = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  text-align: center;
  justify-content: space-between;
  width: 100%;
`;

export const AppVisitCenter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  margin-bottom: 10px;
  margin-top: 10px;
  padding: 0px 15px;
`;

export const RecordVisitDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  margin-bottom: 1.5em;
  font-weight: 500;
  font-size: 1rem;
`;
/** Record visit intro: label/input pairs, two per row (Role | Type, Date | Start). */
export const RecordVisitIntroGrid = styled.div`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto minmax(0, 1fr);
  column-gap: 8px;
  row-gap: 12px;
  align-items: end;
  margin-bottom: 1em;
  & .react-datepicker__input-container input {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 1.5;
  }
  @media (max-width: 600px) {
    grid-template-columns: auto minmax(0, 1fr);
  }
`;
export const FormVisitDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-weight: 500;
  font-size: 1rem;
`;

export const TimerDiv = styled.div<{
  edit?: boolean;
  minimize?: boolean;
}>`
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  ${(props) =>
    props.edit
      ? `margin-right: 10px;
         margin-left: 10px;`
      : `background-color: ${props.theme.palette.background.timer};
         width: 100px;
         padding: 2px;
         height: 25px;`}
  ${(props) => (props.minimize ? `height: 20px;` : ``)}
  ${(props) => (props.edit ? `;` : `box-shadow: 0 0 10px #dc143c;`)}
`;

export const TimerText = styled.span`
  font-size: 1.2rem;
  font-weight: 600;
  padding: 1px;
`;

export const CloseVisitButtonsDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  flex-shrink: 0;
  width: 100%;
  @media (max-width: 600px) {
    flex-direction: column;
    width: 100%;
    align-items: stretch;
    gap: 8px;
    & > * {
      width: 100%;
    }
  }
`;

/** Summary row on top, Discard/Submit actions pinned to the bottom. */
export const RecordVisitSummaryLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
  min-width: 0;
`;

/** RecordVisit summary items stacked in one column, left-aligned. */
export const RecordVisitSummaryColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  min-width: 0;
  font-size: 1rem;
  font-family: inherit;

  & > div {
    width: auto;
    padding-left: 0;
    padding-right: 0;
  }
`;
// todo
export const EditVisitDiv = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: left;
  flex-wrap: wrap;
  gap: 5px;
`;
export const EditTimeDiv = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
`;

export const VisitAttributeRowDiv = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

export const VisitAttributeTitle = styled.div`
  color: ${(props: any) => props.theme.palette.text.secondary};
  font-weight: 500;
  font-size: 1.2rem;
  text-decoration: underline;
  text-align: center;
`;
export const VisitWarningTitle = styled.div`
  color: ${(props: any) => props.theme.palette.text.secondary};
  font-weight: 500;
  font-size: 1.2rem;
  text-decoration: underline;
  text-align: center;
  padding-bottom: 2rem;
`;

export const MultiRolesDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 10px;
  /*max-width:200px;*/
`;
// todo
export const FormDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const VisitHeader = styled.div`
  display: flex;
  background: ${(props: any) => props.theme.palette.error.light};
  color: ${(props: any) => props.theme.palette.common.white};
  height: 22px;
  align-items: center;
  padding-right: 8px;
  padding-left: 8px;
  justify-content: space-between;
  transform: rotate(270deg);
  text-align: center;
  text-transform: uppercase;
  border-radius: 2px;
  font-weight: 600;
  cursor: pointer;
  transform-origin: 0 0;
  position: absolute;
  bottom: 0;
`;

export const IPULabel = styled.div`
  ${(props) => `color:${props.color};`}
  font-size: 11px;
  text-align: center;
`;

// *** Cell Renderer ****
export const CellDiv = styled.div`
  display: flex;
  justify-content: center;
  min-width: 30px;
`;
export const CellCountDiv = styled.div`
  display: flex;
  justify-content: center;
  min-width: 45px;
`;
export const StyledSpan = styled.span`
  width: 100%;
  height: 100%;
`;
// todo adjust width
export const TaskPlanningGridScroll = styled.div`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: auto;
  overflow-y: visible;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-x: contain;
`;
export const TaskPlanningDiv = styled.div`
  min-height: 100px;
  width: 100%;
  min-width: 0;
`;
export const TasksWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  min-width: 0;
`;

export const IPUChoice = styled.div`
  padding-top: 20px;
  padding-bottom: 5%;
`;

export const SubmitVisitButton = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  justify-content: flex-end;
  align-items: center;
  @media (max-width: 600px) {
    flex-direction: column;
    width: 100%;
    align-items: stretch;
    & button {
      width: 100%;
    }
  }
`;

export const VisitDetailRowWrapper = styled.div`
  height: auto;
  min-height: 100px;
  margin-top: 10px;
  padding-bottom: 10px;
  overflow: auto;
`;

export const VisitWarning = styled.div`
  width: 100%;
  background: ${(props: any) => props.theme.palette.error.light};
  color: ${(props: any) => props.theme.palette.common.white};
  display: flex;
  justify-content: center;
  margin-bottom: 1vh;
`;

export const DisplayDiv = styled.div<{ show: any }>``;
